import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  table: {
    [theme.breakpoints.up('sm')]: {
      width: '80%',
    },
  },
});

const BalanceTotalTable = ({ classes, data }) => {
  const currency = data.currency ? data.currency : '';
  return (
    <Table className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell>Balance ({currency})</TableCell>
          <TableCell>In Orders</TableCell>
          <TableCell>In Cart</TableCell>
          <TableCell>Pay for Cart</TableCell>
          <TableCell>To Dispatch</TableCell>
          <TableCell>Pay to Dispatch</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>{data.balance}</TableCell>
          <TableCell>{data.inworkOrders}</TableCell>
          <TableCell>{data.readyForOrder}</TableCell>
          <TableCell>{data.topupForOrder}</TableCell>
          <TableCell>{data.readyForShipment}</TableCell>
          <TableCell>{data.topupForShipment}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default withStyles(styles)(BalanceTotalTable);
